export default __webpack_public_path__ + "static/banner-5-car-fixes-you-should-be-able-to-do-yourself-16d4d19d02761cbc1eed9a9bf194d5b4.jpg";